/*
----- Callouts ----- 
- Essentially tried to do everything https://get.foundation/sites/docs/callout.html but overlays the callout's onto the page content so these callouts can appear overlapping the page content.
- Callout options:
  - Message [ the content inside of the callout ]
  - Type [ Success, Warning or Alert ]
  - Position [ Top or Side ]
  - Delay [ 1000ms ]
*/

function initialiseAll() {
    // Find all instances of a callout.
    let element = $('[' + expressSelectors()['callouts']['initialise'] + ']');
    if (element.length > 0) {
        element.each(function() {
            // Store context.
            let context = $(this);
            // Get the message.
            let message = context.text();
            // Close Delay.
            let delay = context.data('close-delay');
            // Create notification.
            let callout = createCallout(message, "", undefined, delay);
        
            if (callout) {
                context.addClass('triggered');
            }
        });
    }

    $('body').on('click', '.callout[data-closable] [data-close]', function(event) {
        // Not required anymore as this is handled by the lookup framework.
        //let context = $(event.target).parents('.callout')
        //if (context.hasClass('callout')) {
            //let post = calloutPost(context);
        //}
        // Grab context.
        let context = $(this);
        // Get container.
        let container = context.parents('.callout');
        // Remove container.
        container.remove();

        
    });
}

// Actually create the callout.
function createCallout(message, type = 0, position = "side", delay = calloutDefaultOpenTime) {
    let calloutType = type;
    // If a string has been provided use that to set the style otherwise default back to the old way of doing things.
    if (typeof(type) == "string") {
        if (!type.length) {
            calloutType = "success";
        } else {
            calloutType = type;
        }
    } else {
        if (calloutType == 0) { 
            calloutType = "success";
        } else if (calloutType == 1) {
            calloutType = "warning";
        } else if (calloutType == 2) {
            calloutType = "alert";
        } else {
            calloutType = "primary";
        }
    }
    if (AXISDebug.level() >= 2) {
        AXISDebug.output(1, "Notifications: attempting to create callout here is the message: [" + message + "], the type: " + calloutType + ", the position: " + position + " and the close delay is: " + delay +"s");
    }

    //Check if notification container exists.
    if ($('.callout-container.' + position).length == 0) {    
        $('body').append("<div class='callout-container " + position + "'></div>");
    }

    // Check if notification already exists.
    let calloutExists = false;
    $(".callout-container .callout").each(function() {
        // Store context.
        let context = $(this);
        // Get its message.
        let calloutMessage = context.text();
        // Check whether message equals the new notification message.
        if (calloutMessage == message) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Notifications: matched callout to existing callout, attempting to cancel click event.");
            }
            // Set exists flag.
            calloutExists = true;
            // Exit
            return false;
        }
    });

    // If callout already exists then exit.
    if (calloutExists) {
        return false;
    }

    //Wrap the content inside of a callout.
    var callout = "<div class=\"callout "+ calloutType +"\" data-closable>" + message + "</div>"
    //Output callout inside of the notification container.
    $('.callout-container.' + position).append(callout);  
    //Start the close process.
    closeCallout(position, delay);

    return true;
}

function close(callout, delay) {
    return new Promise(function cb(resolve, reject) {
        callout.on('mouseenter', () => {
            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1,"Callouts: Callout close aborted due to cursor being within the callout container.")
            }
            // Clear timeout to prevent callout from closing..
            clearTimeout(closeTimout);
        });
        callout.on('mouseleave', () => {
            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1,"Callouts: Cursor has left the callout area, attempting to close again.")
            }
            resolve({"mouse-leave": true});
        });
        // Prepare for callout to slide out.
        callout.addClass('animated');

        let closeTimout = setTimeout(() => {
            callout.addClass('slideOutRight');
            resolve(true);
        }, delay);
    });
}

// Callout close process.
function closeCallout(position, delay) {
    if (!position) {
        AXISDebug.output(3, "Cannot close notification as position not defined eg. Top or side")
    }
    var callout = $('.callout-container.' + position + ' .callout').first();

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, callout.attr('class') + " will close after " + delay + "s.")
    }
    if (callout.hasClass('animated')) {
        //Keep going to the next notification until you find one that is not prepared to animated.
        while (callout.hasClass('animated')) {
            callout = callout.next();
        }
    }

    close(callout, delay).then((data) => {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Callouts: Clear up DOM");
        } 
        // Add additional delay to not remove instantly.
        let additionalDelay = (data.hasOwnProperty('mouse-leave') ? 500 : 0);
        // Remove listeners.
        callout.off('mouseleave mouseenter');
        //Once promise has been resolved remove the notification.
        setTimeout(() => {
            // Remove callout from DOM.
            callout.remove();
            // Clear out container if no other callouts are active.
            containerCleanup(position);
        }, additionalDelay);
    }).catch((data) => {
        AXISDebug.output(3,"Callouts: Callout failed to close", callout);
    });
}

// Check if any notifications exist, if non then remove the container.
function containerCleanup(position) {
    if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Callouts: Attempting to remove the " + position + " callout container");
    }
    if ($('.callout-container.' + position + ' .callout').length == 0) {
        $('.callout-container.' + position ).remove();
    }
}

function calloutPost(context) {
    // Get the callout type.
    let data = "calloutType=" + context.data('notification-type');
    // Get the post url.
    let postUrl = AXISAjax.postUrl(context, false, false, true);
    // Post to server.
    if (postUrl) {
        AXISAjax.post(postUrl, data, 'html', context);
    }   
    
    let observer = new MutationObserver(function() {
        if (context.css('display') == "none") {
            context.remove();
            observer.disconnect();
        }
    });
    // Set observer to watch if any attributes get changed.
    observer.observe(context[0], {attributes: true});
}

var callouts = $.callouts = {
    initialiseAll: () => {
        return initialiseAll();
    }, 
    create: (message, type, position, delay) => {
        return createCallout(message, type, position, delay);
    },
    containerCleanup: () => {
        return containerCleanup();
    }
}

export { callouts }